export const OBJECTID = 'objectId';
export const FEATURE_LAYER_OPACITY = 0.5;
export const LABELING_INFO_SYMBOL = {
  type: 'text',
  color: 'white',
  haloSize: '0',
  text: '',
  backgroundColor: '#828282',
  font: {
    family: 'Roboto Condensed',
    style: 'italic',
    weight: 'normal',
    size: 12
  }
};
